import { useEffect } from "react";
import { useRouter } from "next/router";
import useCodeVersionStatus, {
  CodeVersionStatus,
} from "../../utils/hooks/codeVersionStatus";

export default function EnsureLatest() {
  const router = useRouter();

  const codeVersionStatus = useCodeVersionStatus();

  useEffect(() => {
    if (codeVersionStatus == CodeVersionStatus.OUT_OF_DATE) {
      router.reload();
    }
  }, [codeVersionStatus, router]);

  return null;
}
